import React from 'react';
import MixerInformationRouter from './MixerInformationRouter';

export default function MixerInformationPage() {
  return <MixerInformationRouter />;
}
